/* eslint-disable */
import AWS from 'aws-sdk';

const region = process.env.REACT_APP_REGION;

export const getCognitoCredentials = async (cognitoTokenData) => {
  try {
    if (!cognitoTokenData || !cognitoTokenData?.IdentityId) {
      throw new Error('Invalid Cognito token data provided.');
    }

    const params = {
      IdentityId: cognitoTokenData?.IdentityId,
      Logins: {
        'cognito-identity.amazonaws.com': cognitoTokenData?.Logins['cognito-identity.amazonaws.com']
      }
    };

    const cognitoIdentity = new AWS.CognitoIdentity({ region });

    const credentials = await new Promise((resolve, reject) => {
      cognitoIdentity.getCredentialsForIdentity(params, (err, data) => {
        if (err) {
          console.error('Error getting credentials for identity:', err);
          reject(err);
        } else if (!data?.Credentials) {
          reject(new Error('No credentials returned by Cognito.'));
        } else {
          resolve({
            identityId: data?.IdentityId,
            accessKeyId: data?.Credentials.AccessKeyId,
            secretKey: data?.Credentials.SecretKey,
            sessionToken: data?.Credentials.SessionToken
          });
        }
      });
    });

    return credentials;
  } catch (error) {
    console.error('Error fetching Cognito credentials:', error);
    throw error;
  }
};
